import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Injector } from '@angular/core';
import { Component, Input, ViewChild, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { StatusNotificationsDto } from '@dto/statusNotificationDto';
import { TableColumn } from '@models/tableColumn';
import { TableFilter } from '@models/tableFilter';
import { TableOptions } from '@models/tableOptions';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { StatusNotificationsService } from '@services/entity/statusNotifications.services';
import { FormService } from '@services/form/form.service';
import { plainToClass } from 'class-transformer';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';

@Component({
  selector: 'app-statusnotifications-table',
  templateUrl: './statusnotifications.component.html',
  styleUrls: ['./statusnotifications.component.scss']
})
export class StatusNotificationsTableComponent extends AbstractEntitiesTableComponent implements OnInit, OnDestroy {

  public className = 'StatusNotificationsTableComponent';
  public activeComponentClassName: string = 'StatusNotificationsTableComponent';
  public entities: StatusNotificationsDto[];
  public filter: TableFilter;

  public notivicationDisabled: boolean = true;

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn1:Name/Bezeichner`, property: 'chargingStationName' },
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn10:ConnectorId`, property: 'connectorId'},
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn2:Status`, property: 'displayStatus', options: { 'isHTML': true } },
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn3:Ladestationzeit`, property: 'timestampFromChargeBox', options: { columnPipe: { pipe: new DEDatePipe() } } },
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn4:Serverzeit`, property: 'timestampFromServer', options: { columnPipe: { pipe: new DEDatePipe() } } },
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn5:Info`, property: 'info'},
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn6:VendorId`, property: 'vendorId'},
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn7:vendorErrorCode`, property: 'vendorErrorCode'},
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn8:ErrorCode`, property: 'errorCode'},
    { columnDescription: $localize`:@@ChargingStationsStatusHistoryTableColumn9:Kunde`, property: 'customerName'},
  ];

  public tableOptions: TableOptions = { hideActions: true, rowRouterLink: 'chargingstation/{chargingStationId}' };

  @ViewChild('ngbDropdown') notificationMail: NgbDropdown;


  constructor(
    public chargingStationsService: StatusNotificationsService,
    public formService: FormService,
    injector: Injector) {
    super(chargingStationsService, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tableFunctions.sortColumn = 'timestampFromServer';
    this.tableFunctions.sortDirection = 'desc';
    this.createForm();
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      notificationSend: new UntypedFormControl(),
      mailaddress: new UntypedFormControl(),
    });
    this.formService.form.get('mailaddress').disable();
    this.formService.formCreated = true
  }

  notification() {
    this.formService.form.get('notificationSend').value ? this.formService.form.get('mailaddress').enable() : this.formService.form.get('mailaddress').disable();
  }

  async initializeEntities() {
    var customerId = this.activatedRoute.parent.snapshot.params.key;
  }

  mapStatus() {
    this.entities.forEach(e => {
      switch (e.statusId) {
        case 1:
          e.displayStatus = "<span class='badge rounded-pill bg-primary'>" + e.status.name + "</span>";
          break;
        case 2:
          e.displayStatus = "<span class='badge rounded-pill bg-success'>" + e.status.name + "</span>";
          break;
        case 3:
          e.displayStatus = "<span class='badge rounded-pill bg-warning' style='background-color:orange'>" + e.status.name + "</span>";
          break;
        case 4:
          e.displayStatus = "<span class='badge rounded-pill bg-danger'>" + e.status.name + "</span>";
          break;
        case 5:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 6:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 7:
          e.displayStatus = "<span class='badge rounded-pill bg-reserved'>" + e.status.name + "</span>";
          break;
        case 8:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 9:
          e.displayStatus = "<span class='badge rounded-pill bg-info'>" + e.status.name + "</span>";
          break;
        case 10:
          e.displayStatus = "<span class='badge rounded-pill bg-danger'>" + e.status.name + "</span>";
          break;
        case 11:
          e.displayStatus = "<span class='badge rounded-pill bg-secondary'>" + e.status.name + "</span>";
          break;
        default:
          e.displayStatus = "<span class='badge rounded-pill bg-secondary'>" + e.status.name + "</span>";
          break;
      }
    })
  }

  matches(entity: StatusNotificationsDto, term: string) {
    var datePipe = new DEDatePipe();
    var timestamp_ChargeBox = datePipe.transform(entity.timestampFromChargeBox);
    var timestamp_Server = datePipe.transform(entity.timestampFromServer);

    return entity.chargingStationName?.toLocaleLowerCase().includes(term.toLowerCase())
      || entity.status?.name?.toLowerCase().includes(term.toLowerCase())
      || timestamp_ChargeBox?.includes(term.toLowerCase())
      || timestamp_Server?.includes(term.toLowerCase())
      || entity.chargingStationId?.toLowerCase().includes(term.toLowerCase())
      || entity.chargingStationName?.toLowerCase().includes(term.toLowerCase())
      || entity.info?.toLowerCase().includes(term.toLowerCase())
      || entity.vendorId?.toLowerCase().includes(term.toLowerCase())
      || entity.vendorErrorCode?.toLowerCase().includes(term.toLowerCase())
      || entity.errorCode?.toLowerCase().includes(term.toLowerCase())
      || entity.customerName?.toLowerCase().includes(term.toLowerCase())
  }

  setFilter(filter: TableFilter) {
    filter.filterDLM = true;
    filter.filterSignal = true;
    this.filter = filter;
    this.updateTable();
  }

  async updateTable() {
    this.tableReady = false
    this.chargingStationsService.getAllStatusNotifications(this.filter).subscribe(result => {
      this.entities = plainToClass(StatusNotificationsDto, result)
      this.mapStatus()
      super.setupTable()
      this.tableReady = true
   }, error => {
      this.messageService.setError(error);
   });
  }
}
